import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function BasicMenu({updateParagraph}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (mType) => {
    let newMessage = "";
  if (mType === "marketing") {
    newMessage = `Hi {{customer}},

We’re excited to introduce {{product}}, designed to make your life easier. For a limited time, enjoy an exclusive {{discount}}% off your first purchase!

Don't miss out—grab yours today!

[Shop Now]

Best,
{{Your Company Name}}`;
  } else if (mType === "email") {
    newMessage = `Dear {{Hiring Manager’s Name}},

I hope you're doing well! I recently came across the {{Job Title}} position at {{Company Name}}, and I’m eager to bring my {{relevant skill/experience}} to your team. I’d love the opportunity to discuss how I can contribute.

Would you be available for a quick chat this week? Looking forward to hearing your thoughts!

Best regards,
{{Your Name}}
{{Your Contact Information}}`;
  } else if (mType === "birthday") {
    newMessage = `Hey {{friend’s name}},

I’m super excited to celebrate my birthday, and it wouldn’t be the same without you! 🎊 Join us for a fun-filled day with good food, great company, and lots of laughter.

📅 Date: {{date}}
🕒 Time: {{time}}
📍 Location: {{venue/address}}

Let me know if you can make it! Hope to see you there! 🎁🎈

Cheers,
{{your name}}`;
  }

  if (newMessage) {
    updateParagraph(newMessage);
  }

  setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Examples
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => handleClose('marketing')}>Marketing Campaign</MenuItem>
        <MenuItem onClick={() => handleClose('email')}>Cold Email</MenuItem>
        <MenuItem onClick={() => handleClose('birthday')}>Birthday Invite</MenuItem>
      </Menu>
    </div>
  );
}
